var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeditation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gradient-233)",
    strokeMiterlimit: 10,
    strokeWidth: 2.88131,
    d: "M 77.618088,50.18117 C 72.358647,55.609817 66.798482,51.990719 64.370999,47.851647 60.116235,40.594179 60.211892,32.504224 48.568542,32.504224",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1",
    style: {
      stroke: "url(#linearGradient11)",
      strokeWidth: 3.581,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gradient-233)",
    strokeMiterlimit: 10,
    strokeWidth: 2.88131,
    d: "m 18.487413,50.18117 c 5.259425,5.428647 10.819533,1.809549 13.247102,-2.329523 4.254783,-7.257468 4.159127,-15.347423 15.802473,-15.347423",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2",
    style: {
      stroke: "url(#linearGradient12)",
      strokeWidth: 3.581,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gradient-233)",
    strokeMiterlimit: 10,
    strokeWidth: 2.88131,
    d: "m 42.442058,50.570948 v 2.796384 c 0,0 -0.28109,2.970014 -2.649811,2.970014 H 28.485279 c -3.399858,0 -5.166056,2.380182 -5.166056,4.111287 0,2.24267 3.352669,3.23429 5.310101,4.405695 0,0 24.170319,10.463994 28.502258,11.172161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path3",
    style: {
      stroke: "url(#linearGradient13)",
      strokeWidth: 3.881,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gradient-233)",
    strokeMiterlimit: 10,
    strokeWidth: 2.88131,
    d: "m 53.300124,50.570948 v 2.796384 c 0,0 0.28109,2.970014 2.649822,2.970014 h 11.306938 c 3.39986,0 5.166053,2.380182 5.166053,4.111287 0,2.24267 -3.352686,3.23429 -5.310099,4.405695 0,0 -22.864915,9.139401 -29.505791,11.172161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path4",
    style: {
      stroke: "url(#linearGradient14)",
      strokeWidth: 3.881,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gradient-233)",
    strokeMiterlimit: 10,
    strokeWidth: 2.88131,
    d: "m 55.404181,20.578213 c 0,4.171643 -3.22936,7.553054 -7.213424,7.553054 -3.983971,0 -7.213417,-3.381411 -7.213417,-7.553054 0,-4.171581 3.229446,-7.553022 7.213417,-7.553022 3.984064,0 7.213424,3.381441 7.213424,7.553022",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path5",
    style: {
      stroke: "url(#linearGradient15)",
      strokeWidth: 3.281,
      strokeDasharray: "none"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 82,
    height: 82,
    rx: 41,
    stroke: "url(#gradient-233)",
    strokeWidth: 6,
    shapeRendering: "geometricPrecision",
    id: "rect5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    y1: 46,
    id: "gradient-233",
    x1: 4,
    y2: 46,
    x2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523687,
    stopColor: "#56CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-233",
    id: "linearGradient11",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.86408963,0,0,0.90477444,6.0983217,3.4851457)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-233",
    id: "linearGradient12",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.86408963,0,0,0.90477444,6.0983217,3.4851457)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-233",
    id: "linearGradient13",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.86408963,0,0,0.90477444,6.0983217,3.4851457)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-233",
    id: "linearGradient14",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.86408963,0,0,0.90477444,6.0983217,3.4851457)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-233",
    id: "linearGradient15",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.86408963,0,0,0.90477444,6.0983217,3.4851457)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditation);
export default __webpack_public_path__ + "static/media/meditation.7583a93f38d95148d80285986467dc4a.svg";
export { ForwardRef as ReactComponent };